<template>
  <div class="section">
    <div class="section-head">
      <img src="~@/assets/img/itles-webapp-videoClass/title-zj.png" alt />
    </div>
    <div class="section-conect">
      <div class="section-item" v-for="(teacher, index) in teacherList" :key="index">
        <p class="teahcer-info">
          <span class="name">{{teacher.name}}</span>
          <span v-if="teacher.type" class="type">{{ teacher.type }}</span>
        </p>
        <p
          class="des"
        >{{teacher.introduce}}</p>
        <div class="link" @click="handleOpenApp(teacher.id)"><span class="link-msg">了解更多</span> <van-icon name="arrow" class="icon" /></div>
        <van-image
          class="teacher"
          fit="cover"
          :src="teacher.adv_pic"
          alt
        >
          <template v-slot:error>加载失败</template>
        </van-image>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon } from 'vant';
import { isIos, isAndroid } from "@/utils/utils.js";

export default {
  props:['teacherList'],
  data() {
    return {

    };
  },
  methods: {
    handleOpenApp(teacherId) {
      if (isIos()) {
        window.webkit.messageHandlers.openTeacherDetail.postMessage(`${teacherId}`);
      }
      if (isAndroid()) {
        window.app.openTeacherDetail(`${teacherId}`);
      }
    },
  },
  mounted() {
   
  },
  created() {
  }
};
</script>
<style lang="scss" scoped>
.section-head {
  img {
    display: block;
    width: tovw(368);
    height: tovw(48);
    margin: tovw(40) auto;
    margin-top: tovw(80);
  }
}
.bg {
  display: block;
  width: 100%;
  height: tovw(160);
  margin: 0 auto;
}
.section-conect {
  background: #fff url(~@/assets/img/itles-webapp-videoClass/zj_bg.png) no-repeat;
  background-position: tovw(330) 0;
  background-size: tovw(334) tovw(88);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
  border-radius: tovw(24);
  padding: tovw(40) 0 tovw(40) tovw(40);
  position: relative;

  .section-item {
    position: relative;
    border-bottom: 1px solid rgba(0,0,0,.6);
    margin-bottom: tovw(40);

    &:last-child {
      border: none;
      margin-bottom: 0;
    }

    p {
      overflow: hidden;
    }
    .des {
      margin: tovw(24) 0;
      font-size: tovw(26);
      font-family: PingFangSC-Light, PingFang SC;
      color: rgba(0, 0, 0, 0.6);
      line-height: tovw(40);
      width: tovw(414);
      height: tovw(120);
      text-overflow: -o-ellipsis-lastline;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    /* span {
      display: block;
      float: left;
      height: tovw(48);
      line-height: tovw(48);
      font-family: PingFangSC-Semibold, PingFang SC;
    } */
    .teahcer-info {
      margin-bottom: tovw(24);
    }
    .name {
      font-size: tovw(36);
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
    }
    .type {
      margin-top: tovw(4);
      font-size: tovw(24);
      font-weight: 300;
      color: rgba(0, 0, 0, 0.8);
      padding-left: tovw(50);
      position: relative;

      &::after {
        display: block;
        content: "";
        position: absolute;
        width: 1px;
        height: tovw(36);
        top: tovw(6);
        left: tovw(24);
        border-left: 1px solid #ccc;
      }
    }

    .teacher {
      position: absolute;
      width: tovw(180);
      height: tovw(280);
      bottom:0;
      right:0;
    }

    .link {
      margin-bottom: tovw(24);
      display: inline-block;
      font-size: tovw(26);
      line-height: tovw(42);
      
      .link-msg {
        vertical-align: middle;
        color:rgba(0, 0, 0, 0.6);
      }
      .icon {
        vertical-align: middle;
        color:rgba(0, 0, 0, 0.6);
      }
    }
  }
}
</style>